module.exports = __webpack_public_path__ + "static/media/gloveOccurrences.52c9e28c.png";